import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { useAuthContext } from "./hooks/useAuthContext";
import { useEffect, useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "./constants/ApiConntection";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import JoinPage from "./pages/joinPage/JoinPage";
import VerifyEmail from "./pages/verifyEmail/VerifyEmail";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./pages/loginPage/Login";
import LoggedIn from "./pages/dashBoard/loggedIn/LoggedIn";
import MyAccount from "./pages/myAccount/MyAccount";
import PaymentSuccess from "./pages/success/PaymentSuccess";
import PaymentUnsuccessful from "./pages/success/PaymentUnsuccessful";
import Enquiries from "./pages/dashBoard/enquiries/Enquiries";
import CounsellorProfile from "./pages/dashBoard/counsellorProfile/CounsellorProfile";
import Availability from "./pages/dashBoard/availability/Availability";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";
import TermsAndConditions from "./pages/terms/TermsAndConditions";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import BrandAssets from "./pages/brand-assets/BrandAssets";


function App() {
  const { user, dispatch } = useAuthContext();

  const [profile, setProfile] = useState(null);

const fetchData = async () => {
  try {
    const response = await axios.get(
      `${ApiConnectionString}/api/counsellorProfile/`,
      {
        headers: { Authorization: `bearer ${user.token}` },
      },
    );

    setProfile(response.data);
  } catch (error) {
    dispatch({ type: "LOGOUT", payload: {} });
  }
};

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user]);

  useEffect(() => {
    const existingUser = JSON.parse(localStorage.getItem("user"));
    const getUser = async () => {
      try {
        await axios.get(`${ApiConnectionString}/api/user/checkstatus/`, {
          headers: { Authorization: `bearer ${existingUser.token}` },
        });
        dispatch({ type: "WELCOMEBACK", payload: existingUser });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          dispatch({ type: "LOGOUT", payload: {} });
        }
      }
    };
    if (existingUser) getUser();
  }, [dispatch]);

  return (
    <div className="App">
      
      <BrowserRouter>
        <Navbar profile={profile}/>
        <div className="container">
          <Routes>
            <Route path="/" element={!user ? <Login /> : <LoggedIn />} />
            <Route path="/Join" element={<JoinPage />} />
            <Route path="/verifyEmail/:token" element={<VerifyEmail />} />
            <Route path="/myaccount" element={<MyAccount />} />
            <Route path="/success" element={<PaymentSuccess />} />
            <Route path="/unsuccessful" element={<PaymentUnsuccessful />} />
            <Route
              path="profile"
              element={<CounsellorProfile profile={profile} user={user} />}
            />
            <Route
              path="/Enquiries"
              element={<Enquiries profile={profile} user={user} />}
            />
            <Route
              path="/Availability"
              element={<Availability profile={profile} user={user} />}
            />
    <Route path="/resetPassword/:token" element={<ResetPassword />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
               <Route path="/terms" element={<TermsAndConditions />} />
               <Route path="/brand-assets" element={<BrandAssets />} />

          </Routes>


        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
